import BigNumber from 'bignumber.js';
import {
  CONSULT_ACCEPTED,
  CONSULT_CANCELLED,
  CONSULT_FINISHED,
  CONSULT_PENDING,
  CONSULT_SOURCE_MANADR_LITE,
  CONSULT_TIMEOUT,
} from 'Constants/consults';

import { getYearOlds } from './date-utils';

const LABEL_CONSULT = {
  [CONSULT_PENDING]: 'Pending',
  [CONSULT_ACCEPTED]: 'Accepted',
  [CONSULT_CANCELLED]: 'Cancelled',
  [CONSULT_TIMEOUT]: 'Timeout',
  [CONSULT_FINISHED]: 'Ended',
};

export const getLabelConsult = status => LABEL_CONSULT[status] || 'Pending';

export const findMiniumFeeByCurrency = (list, currency) =>
  list.find(i => i.currency.currencyCode === currency);

const calculatePrescription = (prescriptionOrders = []) =>
  prescriptionOrders.reduce(
    (currentValue, item) =>
      +new BigNumber(currentValue).plus(item.fee.subTotal).decimalPlaces(2, 1),
    0,
  );

const calculateSubsidy = (discountDetail, total) => {
  const bigTotal = new BigNumber(total);
  let subsidy = 0;
  if (discountDetail) {
    const { unit = 'percent', value = 20 } = discountDetail;
    if (unit === 'percent') {
      subsidy = +bigTotal.multipliedBy(value).dividedBy(100).decimalPlaces(2, 1);
    } else subsidy = value;
    if (subsidy < 0) subsidy = -subsidy;
  }
  return subsidy;
};

export const calculateChatFee = consultFee => {
  const {
    subsequentFee,
    initialFee,
    floorConsultFee,
    discountDetail,
    feeSetting,
    discount: couponDiscount,
    consult: { subMinutesCount, patientMessageCount },
  } = consultFee;
  const videoFee = new BigNumber(subMinutesCount).multipliedBy(
    feeSetting?.subsequentMinuteFee || 0,
  );
  const bigSubTotal = videoFee.plus(subsequentFee).plus(initialFee);
  const subTotal = +bigSubTotal.decimalPlaces(2, 1);
  const bigTotalBeforSubsidy = +bigSubTotal.decimalPlaces(2, 1);
  const subsidy = calculateSubsidy(discountDetail, bigTotalBeforSubsidy);
  const total = +new BigNumber(bigTotalBeforSubsidy).minus(subsidy).decimalPlaces(2, 1);
  const finalPrice =
    total - couponDiscount <= 0 ? 0 : +new BigNumber(total - couponDiscount).decimalPlaces(2, 1);
  const error =
    (total - couponDiscount < floorConsultFee &&
      total - couponDiscount !== 0 &&
      patientMessageCount > 0) ||
    total - couponDiscount < 0;
  return {
    subTotal,
    total,
    error,
    subsidy,
    finalPrice,
  };
};

export const calculateTotal = (consultFee, userDiscount) => {
  let total = 0;
  let subTotal = 0;
  let tax = 0;
  let error = false;
  let adminFee = 0;
  let isConsultFinished = false;
  if (consultFee) {
    const {
      prescriptionOrders,
      priorityQueueFee,
      deliveryFee,
      taxPercent,
      adminFee: adminFeeConsult,
      discount: couponDiscount,
      consult: { status },
    } = consultFee;
    // calculate chat consult
    const { total: consultTotal } = calculateChatFee(consultFee);
    const prescription = prescriptionOrders ? calculatePrescription(prescriptionOrders) : 0;
    const bigSubTotal = new BigNumber(consultTotal);
    subTotal = +bigSubTotal.plus(prescription).plus(priorityQueueFee).decimalPlaces(2, 1);
    tax = +new BigNumber(subTotal)
      .minus(couponDiscount)
      .minus(userDiscount)
      .multipliedBy(taxPercent)
      .dividedBy(100)
      .decimalPlaces(2, 1);
    // add delivery fee
    total = +new BigNumber(subTotal)
      .plus(deliveryFee)
      .minus(couponDiscount)
      .minus(userDiscount)
      .plus(tax)
      .decimalPlaces(2, 1);
    // add admin fee
    isConsultFinished = status === CONSULT_FINISHED;
    if (isConsultFinished) {
      adminFee = adminFeeConsult;
      total = +new BigNumber(total).plus(adminFee).decimalPlaces(2, 1);
    }
    error = total < 0 || total > subTotal;
  }
  return {
    total,
    subTotal,
    tax,
    error,
    adminFee,
  };
};
export const isMNDRLite = sourceType => sourceType === CONSULT_SOURCE_MANADR_LITE;

export const calculateYearsOld = dateOfBirth => {
  const yearsDiff = getYearOlds(dateOfBirth);
  return `${yearsDiff} years old`;
};

export const getOtterClinicalTermLabel = (code, codeSet) =>
  codeSet.find(item => item.value?.trim()?.toLowerCase() === code?.trim()?.toLowerCase())?.label ??
  undefined;

export const viewCurrency = currency => {
  if (currency === null || currency === undefined) {
    return 'N/A';
  }
  return Number(currency).toFixed(2);
};

export const findClinicIdFromClinicsMapping = (clinics, doctorId) => {
  const clinic = clinics.find(item => item.doctorId === doctorId);
  return clinic?.clinicId;
};
